<template>
    <div class="relative w-full">
        <form @submit.prevent="subscribe()" class="relative flex w-full" :class="noMargin ? '' : 'mt-12'">
            <input
                v-model="email"
                class="flex-1 bg-gray-700 focus:bg-gray-600 text-white placeholder-gray-300 focus:placeholder-gray-200 text-sm leading-none rounded-sm focus:outline-none mr-2 sm:mr-3 px-4 sm:px-5 py-4 transition-all duration-300 ease-in-out-quad"
                type="email"
                name="EMAIL"
                value=""
                placeholder="Email Address"
                required
            />

            <button
                class="bg-gray-800 hover:bg-aqua-800 text-aqua-400 hover:text-white text-sm rounded-sm focus:outline-none px-4 sm:px-8 py-4 transition-all duration-300 ease-in-out-quad"
                type="submit"
            >
                Subscribe
            </button>
        </form>

        <div
            class="absolute bottom-0 inset-x-0 flex justify-center items-center w-full font-mono text-xs sm:text-sm pt-4 transition-opacity duration-300 ease-in-out-quad transform translate-y-full"
            :class="response > '' ? 'opacity-100 visible' : 'opacity-0 invisible'"
        >
            {{ response }}
        </div>
    </div>
</template>

<script>
// import axios from 'axios';

export default {
    props: ['noMargin', 'mailingList', 'api'],

    data() {
        return {
            email: '',
            response: ''
        };
    },

    methods: {
        subscribe() {
            this.response = '';

            /* axios
                .post(tnaqua.ajaxurl, {
                    action: 'newsletter',
                    email: this.email,
                    api: this.api,
                    list: this.mailingList
                })
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.log(`errorrr`);
                    console.log(error);
                }); */

            $.ajax({
                url: tnaqua.ajaxurl,
                type: 'POST',
                data: {
                    action: 'newsletter',
                    email: this.email,
                    api: this.api,
                    list: this.mailingList
                }
            })
            .done(data => {
                window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                    'event': 'signupSubmit'
                });
                this.response = data;
            })
            .fail(() => {
                console.log(`API request didn't load!`);
            });
        }
    }
};
</script>
